import React, { useState } from 'react';
import AddPortfolioItemModalWrapper from './components/AddPortfolioItemModal/AddPortfolioItemModalWrapper';
import AddPortfolioItemCTA from './AddPortfolioItemCTA';

const AddPortfolioItemCTAWrapper = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [action, setAction] = useState(props.action);

  return (
    <>
      <AddPortfolioItemCTA
        {...props}
        setIsModalOpen={setIsModalOpen}
        action={action}
      />
      {isModalOpen && (
        <AddPortfolioItemModalWrapper
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          productId={props.productId}
          action={action}
          setAction={setAction}
          refetch={props.refetch}
        />
      )}
    </>
  );
};

export default AddPortfolioItemCTAWrapper;
